/**
 * SDK Constants
 */

/**
 * CDN base URL for Analyzify assets
 */
export const CDN_BASE = 'https://cdn-v4.analyzify.app/assets';

/**
 * Core scripts that are always loaded
 */
export const CORE_SCRIPTS = [
  'an_analyzify.js',
  'app_embed.js',
] as const;

/**
 * Platform-specific scripts (loaded conditionally based on config)
 */
export const PLATFORM_SCRIPTS = {
  ga4_gads: 'an_ga4_gads.js',
  facebook: 'an_fb.js',
  gtm: 'an_gtm.js',
  tiktok: 'an_tiktok.js',
  pinterest: 'an_pinterest.js',
  bing: 'an_bing.js',
  snapchat: 'an_snapchat.js',
  klaviyo: 'an_klaviyo.js',
  criteo: 'an_criteo.js',
  x: 'an_x.js',
  clarity: 'an_clarity.js',
  hotjar: 'an_hotjar.js',
  gtag_ss: 'an_gtag_ss.js',
} as const;

/**
 * Helper scripts
 */
export const HELPER_SCRIPTS = [
  'f-find-elem.js',
  'f-form-listener.js',
] as const;

/**
 * Third-party integration scripts (loaded conditionally)
 */
export const THIRD_PARTY_SCRIPTS = {
  pageFly: 'an_pageFly.js',
  rebuy: 'an_rebuy.js',
  shogun: 'an_shogun.js',
} as const;

/**
 * Default configuration values
 */
export const DEFAULTS = {
  currency: 'USD',
  locale: 'en',
  country: 'US',
  productIdFormat: 'product_sku' as const,
  chunkSize: 25,
  userIdFormat: 'cid',
  sendUserId: true,
  consentWaitForUpdate: 500,
} as const;

/**
 * Storefront API version
 */
export const STOREFRONT_API_VERSION = '2026-07';

/**
 * Retry configuration for initialization
 */
export const RETRY_CONFIG = {
  maxRetries: 10,
  initialDelay: 500, // ms
  maxDelay: 16000, // ms
} as const;
